import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { navItems } from '../../data/nav';

const Nav = styled.nav<{ $overlay?: boolean; $onDark?: boolean }>`
  position: ${({ $overlay }) => ($overlay ? 'absolute' : 'relative')};
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  color: ${({ $overlay, $onDark, theme }) => ($overlay || $onDark ? theme.colors.white : theme.colors.text)};
`;

const Inner = styled.div`
  width: min(${({ theme }) => theme.layout.content}, calc(100% - 40px));
  min-height: 72px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

const Brand = styled(Link)`
  padding: 10px 0;
  font-size: 1.05rem;
  font-weight: 850;
  letter-spacing: -0.03em;
  text-decoration: none;
`;

const Links = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(12px, 3vw, 28px);
`;

const NavLink = styled(Link)`
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 650;
  text-decoration: none;
  opacity: 0.78;
  transition: opacity 180ms ease;

  &:hover {
    opacity: 1;
  }
`;

const Disabled = styled.span`
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  opacity: 0.36;
  cursor: default;

  @media (max-width: 520px) {
    display: none;
  }
`;

const SiteNav: React.FC<{ overlay?: boolean; onDark?: boolean }> = ({ overlay = false, onDark = false }) => (
  <Nav $overlay={overlay} $onDark={onDark} aria-label="Primary navigation">
    <Inner>
      <Brand to="/">AI4U</Brand>
      <Links>
        {navItems.map((item) =>
          item.enabled ? (
            <NavLink key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ) : (
            <Disabled key={item.to} aria-disabled="true" title="Coming in Phase C">
              {item.label}
            </Disabled>
          ),
        )}
      </Links>
    </Inner>
  </Nav>
);

export default SiteNav;
